const Header = () => {
    return (
        <header>
          <h1>Att göra</h1>  
        </header>
    )
}

export default Header
